import { useEffect, useState } from "react";
import { Gift, Copy, Users, Coins, Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

// Billing: invite creators (TikTok bio link with ?ref=CODE), earn credits per sign-up.
export default function ReferralCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/referrals/me").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const link = `${window.location.origin}${d.path}`;
  const copy = () => navigator.clipboard.writeText(link).then(() => toast.success("Referral link copied — paste it in your TikTok bio.")).catch(() => toast.error("Could not copy."));
  const share = () => (navigator.share ? navigator.share({ title: "Make your own TikTok sound with AI", text: `Create original music for your videos in a minute — ${d.bonus} bonus credits with my link:`, url: link }).catch(() => {}) : copy());
  return (
    <div className="rounded-2xl border border-primary/30 bg-primary/[0.04] p-6" data-testid="referral-card">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h2 className="font-display text-lg font-bold flex items-center gap-2"><Gift size={18} className="text-primary" /> Invite creators, earn credits</h2>
          <p className="text-sm text-muted-foreground mt-1 max-w-xl">Share your link on TikTok. Every creator who signs up gets <b className="text-foreground">+{d.bonus} credits</b>, and you earn <b className="text-foreground">+{d.reward} credits</b> per sign-up (up to {d.monthly_cap} rewarded sign-ups per 30 days).</p>
        </div>
        <div className="flex gap-6 text-center">
          <div><div className="font-display text-2xl font-extrabold" data-testid="referral-total">{d.total}</div><div className="text-[11px] text-muted-foreground inline-flex items-center gap-1"><Users size={11} /> sign-ups</div></div>
          <div><div className="font-display text-2xl font-extrabold text-primary" data-testid="referral-credits">{d.credits_earned}</div><div className="text-[11px] text-muted-foreground inline-flex items-center gap-1"><Coins size={11} /> credits earned</div></div>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 mt-4">
        <code className="flex-1 min-w-[240px] h-10 px-3 rounded-md bg-background border border-border text-xs flex items-center truncate" data-testid="referral-link">{link}</code>
        <Button onClick={copy} variant="outline" className="h-10 gap-1.5" data-testid="referral-copy"><Copy size={14} /> Copy</Button>
        <Button onClick={share} className="h-10 gap-1.5 bg-primary text-primary-foreground" data-testid="referral-share"><Share2 size={14} /> Share</Button>
        <span className="text-xs font-mono text-muted-foreground">code <b className="text-foreground" data-testid="referral-code">{d.code}</b> · {d.month_rewarded}/{d.monthly_cap} this month</span>
      </div>
      {d.recent.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-3 text-[11px] text-muted-foreground" data-testid="referral-recent">
          {d.recent.slice(0, 8).map((r, i) => <span key={i} className="px-2 py-0.5 rounded-full border border-border">{r.name} · +{r.reward}</span>)}
        </div>
      )}
    </div>
  );
}
